/**
 * Diver-facing labels for listing categories. The stored `Listing.category`
 * value never changes ("Intro" stays "Intro" in the DB and in every query) —
 * only what a diver reads.
 */
const CATEGORY_DISPLAY_LABELS: Record<string, string> = {
  Intro: "Try dive · no experience",
};

/** Label to show a diver for a category (falls back to the stored value). */
export function getCategoryDisplayLabel(category: string): string {
  return CATEGORY_DISPLAY_LABELS[category.trim()] ?? category;
}
